import auth from '../modules/auth/routes'
import home from '../views/home/routes'
import eventos from '../views/eventos/routes'
import bailes from '../views/bailes/routes'
import certificado from '../views/certificado/routes'
// import checkout from '../views/checkout/routes'

const defaultRoute = [{ path: '*', redirect: '/' }]

export default [
    ...defaultRoute,
    ...auth,
    ...home,
    ...eventos,
    ...bailes,
    ...certificado
    // ...checkout
]
